/*
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * 
 * This configuration was automatically generated from Keystone
 * during build time to serve as fallback when Keystone is unavailable.
 * 
 * The data is now organized in separate JSON files within this directory:
 * - domains.json: URL to country code mapping
 * - configs.json: Country-specific configurations  
 * - build-info.json: Generation metadata
 * 
 * Generation Details:
 * - Generated: 2026-11-04T01:28:43.251Z
 * - Stage: sit
 * - Source: Keystone (https://services-sit.bees-platform.dev/v1/keystone)
 * - Config Version: 74
 * - Last Updated: 2026-11-02T15:09:40.578Z
 * 
 * To regenerate: npm run build:config
 */

import type { Config } from '@/core/types'

// Use require for JSON files to avoid TypeScript import issues
const domainsData = require('./domains.json')
const configsData = require('./configs.json')
const buildInfo = require('./build-info.json')

export const domains = domainsData

export const config: Config = configsData as Config

export const fallbackMeta = {
  version: buildInfo.configHash || '74',
  generatedAt: buildInfo.buildTimestamp,
  stage: buildInfo.stage,
  source: 'keystone-build-time',
  lastUpdated: buildInfo.keystoneLastUpdated,
  keystoneUrl: buildInfo.keystoneUrl
}

export default {
  domains,
  config,
  fallbackMeta
}
